// Loaded once by the layout, independent of section instances and editor reordering.
// Native Dawn components retain control of all commerce, dialogs and focus traps.
let keyboardNavigation = false;
document.addEventListener('keydown', (event) => {
  if (event.key === 'Tab') keyboardNavigation = true;
});
document.addEventListener('pointerdown', () => {
  keyboardNavigation = false;
});
document.addEventListener('focusin', (event) => {
  if (!keyboardNavigation || !document.body.classList.contains('kdd-design')) return;
  const target = event.target;
  const header = document.querySelector('.section-header');
  if (!(target instanceof HTMLElement) || !header || header.contains(target)) return;
  if (target.closest('dialog, [role="dialog"], .menu-drawer, .cart-drawer')) return;
  requestAnimationFrame(() => {
    if (document.activeElement !== target || !target.isConnected) return;
    const rect = target.getBoundingClientRect();
    const bottom = header.getBoundingClientRect().bottom;
    if (rect.top < bottom && rect.bottom > 0) {
      window.scrollBy({ top: rect.top - bottom - 16, behavior: 'instant' });
    }
  });
});
